import styled from 'styled-components';

export const FeatureTitle = styled.div`
  font-weight: 700;
  font-size: 24px;
  line-height: 29px;
  color: #323232; 
  letter-spacing: -0.2px;
  text-align: center;
  margin: ${({ btnAfter }) => (btnAfter ? '0 0 12px 0' : '48px 0 12px 0')};
`;
export const FeaturesList = styled.ul`
  list-style: none;
  padding: 0;
  margin: ${({ btnAfter }) => (btnAfter ? '0 0 24px 0' : '0 0 60px 0')};
`;

export const StyledItem = styled.li`
  position: relative;
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  color: #323232; 
  text-align: left;
  display: flex;
  align-items: center;
  margin-left: 15px;
  svg {
    width: 9px;
    height: 8px;
    position: absolute;
    top: 5px;
    left: 0;
    text-align: 0;
  }

  > span {
    margin-left: 20px;
  }

  &:not(:last-child) {
    margin-bottom: 8px;
  }
`;

export const MoneyBackWrapper = styled.div`
  max-width: 330px;
  min-width: 330px;
  background-image: url('../images/plans/moneyBackBorder.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  margin-top: ${({ btnAfter }) => (btnAfter ? '50px' : '0px')};
  padding: 0 19px 24px;
  position: relative;
  svg {
    width: 31px;
    height: 35px;
    position: absolute;
    left: 46%;
    top: -6%;
  }
`;

export const MoneyBackTitle = styled.div`
  font-weight: 700;
  font-size: 24px;
  line-height: 31px;
  color: #009E89;
  margin: 40px 0px 12px;
  text-align: center;
`;

export const MoneyBackDescription = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: #909090;
`;

export const StyledBtn = styled.button`
  background-color: transparent;
  text-decoration: underline;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: #909090;
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  border: none;
  margin: 0;
  padding: 0;
  &:focus,
  &:active {
    outline: none;
  }
`;

export const AboutUsWrapper = styled.div`
  max-width: 330px;
  margin: 48px 0 40px;
`;

export const AboutUsTitle = styled.div`
  font-weight: 700;
  font-size: 24px;
  line-height: 29px;
  color: #323232; 
  letter-spacing: -0.2px;
  text-align: center;
  margin-bottom: 20px;
`;

export const PressLogos = styled.div`
  display: flex;
  flex-direction: revert;
  justify-content: center;
  flex-direction: column;
  min-width: 330px;

  > div {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
  }
`;

export const ReviewWrapper = styled.div`
  max-width: 330px;
`;

export const ReviewTitle = styled.div`
  font-weight: 700;
  font-size: 24px;
  line-height: 29px;
  color:  #323232;
  letter-spacing: -0.2px;
  text-align: center;
  margin-bottom: 16px;
`;

export const ReviewItem = styled.div`
  background-color: #ffffff;
  box-shadow: 4px 6px 20px rgba(0, 0, 0, 0.12);
  border-radius: 12px;
  padding: 12px 16px;
  margin-bottom: 12px;

  &:last-child {
    margin-bottom: 24px;
  }
`;

export const ReviewHead = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 8px;
  position: relative;
  >svg {
    &:nth-child(2) {
      margin-left: 7px;
    }
  }
`;

export const MarketLabel = styled.div`
  position: absolute;
  right: 0;
`;

export const ReviewBody = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;
  margin-bottom: 8px;
`;

export const ReviewerPhoto = styled.img`
  width: 30px;
  height: 30px;
`;

export const ReviewerName = styled.span`
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  color: #323232;
`;

export const ReviewText = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  color: #323232;
  letter-spacing: -0.24px;
  text-align: left;
`;

export const TrialHint = styled.div`
  margin-top: 16px;
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
  color: #818181;
  text-align: center;
  transition: opacity 0.3s;
  opacity: ${({ show }) => (show ? 1 : 0)};
`;